import { render, staticRenderFns } from "./SettlementAccount.vue?vue&type=template&id=61a5a0ee&"
import script from "./SettlementAccount.vue?vue&type=script&lang=js&"
export * from "./SettlementAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports